// @flow

export const FAMILY = 'family'
export const SIZE = 'size'
